import { useTemplateContext } from '../../../context/templateContext'
import type { SubTemplateFieldValue } from '../../../types/templateModel'
import { SubTemplatedFieldValueDocumentation } from '../../templateFieldDocumentation/SubTemplatedFieldValueDocumentation'
import { SubTemplateFieldValueExpressionEntry } from './SubTemplateFieldValueExpressionEntry'

type Props = {
  variant: SubTemplateFieldValue
}

/**
 * Displays all the properties of identifiable or subclassed subtemplated field values.
 *
 * Single subclassed sub templated field values are shown as a regular field in the TemplateFieldDetails.
 */
export const SubTemplatedFieldValueContent = ({ variant }: Props) => {
  const { isDraftTemplate } = useTemplateContext()

  return (
    <>
      <SubTemplatedFieldValueDocumentation
        variant={variant}
        isExtendedView={false}
        areFieldsShownAsEditable={isDraftTemplate}
      />
      <SubTemplateFieldValueExpressionEntry
        variant={variant}
        property="defaultSelected"
      />
      <SubTemplateFieldValueExpressionEntry
        variant={variant}
        property="selectable"
      />
    </>
  )
}
